import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePortfolio } from "@/lib/PortfolioProvider";
import Reveal from "@/components/site/Reveal";
import WorkEditorial from "@/components/site/WorkEditorial";

/**
 * WorkPreview — the homepage gateway into /work, staged as a cinematic
 * editorial exhibition rather than a card grid. No section eyebrow: the
 * composition and the headline introduce the section on their own (approved
 * direction). A concise headline + a single "View all work" route, then the
 * exhibition leads.
 */
export const WorkPreview = () => {
    const { branding } = usePortfolio();
    const selected = (branding || []).slice(0, 5);

    return (
        <section
            id="work"
            className="pg-section"
            data-testid="home-work-preview"
            aria-label="Selected work"
        >
            <div className="pg-container">
                <Reveal className="pg-exhibit-head">
                    <h2 className="pg-h2-section pg-exhibit-title" style={{ color: "var(--pg-fg)" }}>
                        Selected work
                    </h2>
                    <Link to="/work" data-testid="home-work-viewall" className="pg-btn-ghost">
                        View all work
                        <ArrowRight className="h-4 w-4" strokeWidth={1.6} />
                    </Link>
                </Reveal>

                <div className="mt-12">
                    <WorkEditorial items={selected} />
                </div>
            </div>
        </section>
    );
};

export default WorkPreview;
